import React, { Component } from 'react'

export default class ModalPublicarLote extends Component {

    constructor(props) {
        super(props);
        this.dialogRef = React.createRef();
    }

    componentDidMount() {
        // Manejar el estado inicial del modal
        if (this.props.isOpen) {
            this.abrirModal();
        }
    }

    componentDidUpdate(prevProps) {
        // Detectar cambios en isOpen para abrir/cerrar el modal
        if (this.props.isOpen !== prevProps.isOpen) {
            if (this.props.isOpen) {
                this.abrirModal();
            } else {
                this.cerrarModalConAnimacion();
            }
        }
    }

    abrirModal = () => {
        if (this.dialogRef.current && !this.dialogRef.current.open) {
            this.dialogRef.current.showModal();
        }
    }

    cerrarModal = () => {
        if (this.dialogRef.current && this.dialogRef.current.open) {
            this.dialogRef.current.close();
        }
    }

    cerrarModalConAnimacion = () => {
        if (this.dialogRef.current && this.dialogRef.current.open) {
            this.dialogRef.current.style.scale = '0';
            setTimeout(() => {
                if (this.dialogRef.current && this.dialogRef.current.open) {
                    this.dialogRef.current.close();
                }
            }, 300);
        }
    }

    manejarCancelar = () => {
        this.cerrarModalConAnimacion();
        setTimeout(() => {
            this.props.cerrarModal();
        }, 300);
    }

    manejarConfirmar = () => {
        this.props.onConfirmar?.();
    }

    obtenerDetalleElemento = () => {
        const { elemento, campoDetalle, detallesAMostrar } = this.props;

        if (!elemento) return [];

        // Si se proporciona un array de detalles a mostrar
        if (detallesAMostrar && Array.isArray(detallesAMostrar) && detallesAMostrar.length > 0) {
            return detallesAMostrar
                .map((campo, index) => {
                    if (typeof campo === 'string') {
                        const valor = elemento[campo];
                        return valor !== null && valor !== undefined ? (
                            <div className="form-group" key={index}>
                                <p className="txt-detail">
                                    {campo} <br /> {valor}
                                </p>
                            </div>
                        ) : null;
                    } else if (typeof campo === 'object' && campo.clave) {
                        const valor = elemento[campo.clave];
                        const etiqueta = campo.etiqueta || campo.clave;
                        return valor !== null && valor !== undefined ? (
                            <div className="form-group" key={index}>
                                <p className="txt-detail">
                                    {etiqueta} <br /> {valor}
                                </p>
                            </div>
                        ) : null;
                    }
                    return null;
                })
                .filter(Boolean); // elimina los nulls
        }

        // Fallback si se especifica solo un campoDetalle
        if (campoDetalle && elemento[campoDetalle]) {
            return [
                <div className="form-group" key="unico">
                    <p className="txt-detail">
                        {campoDetalle} <br /> {elemento[campoDetalle]}
                    </p>
                </div>
            ];
        }

        return [];
    };

    render() {

        const { isOpen } = this.props

        if (!isOpen) return null;
        return (
            <div className="component-modal">

                <dialog
                    className="modal"
                    id="modal-enviar-notificacion"
                    ref={this.dialogRef}
                    onClose={this.manejarCancelar}
                >
                    <div className="modal-content">

                        <div className="modal-body">
                            <h3 className="title"> ¿Desea publicar este lote? </h3>
                            <p className="msg">Se enviarán los documentos dentro del lote a sus destinatarios, esta accion no se podrá deshacer</p>
                            <div className="card">
                                <div className="form-group__inline x4">
                                    {this.obtenerDetalleElemento()}
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button onClick={this.manejarCancelar} className="btn-medium btn-base-outline" id="close-modal" type="reset"> Cancelar </button>
                            <button onClick={this.manejarConfirmar} className="btn-medium btn-success"> Publicar </button>
                        </div>

                    </div>
                </dialog>

            </div>
        )
    }
}
